import { Directive, ElementRef, EventEmitter, HostListener, Output } from "@angular/core"

@Directive({
    selector: "[dropdown]",
    standalone: true
})
export class MenuDropdownDirective {

	@Output() visible: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(private el: ElementRef) {}

	@HostListener("window:resize")
	checkVisibility() {
		if (this.el.nativeElement.offsetParent !== null) this.visible.emit(false);
	}
}